import React from "react";
import commonFunction from "../../../../lib/utils/common";

export default function FlightAutoComplete(props) {
  const onClickHandler = (e) => {
    props.onclickFlightAutoComplete();
  };
  const onFocusInputHandler = (e) => {
    props.onFocusInput();
  };

  // Airport row click — uses AIRPORT_CODE as the booking code
  const selectAirportClickHandler = (airport) => {
    props.onClickSourceAndDestination(
      airport.CITY_NAME,
      airport.AIRPORT_CODE,
      airport.AIRPORT_NAME
    );
  };

  // City row click — uses CITY_CODE as the booking code (represents "all airports")
  const selectCityClickHandler = (city) => {
    props.onClickSourceAndDestination(
      city.CITY_NAME,
      city.CITY_CODE,
      city.CITY_NAME + " all airports"
    );
  };

  /**
   * Render the grouped dropdown list.
   *
   * v2 API can return 3 root-level shapes:
   *   TYPE:"CITY"  → city header row + SUGGESTIONS[] airport children
   *   TYPE:"EXACT" → pinned exact airport row + SUGGESTIONS[] nearby children
   *   (no TYPE)    → legacy flat format: { AIRPORT_CODE, CITY_NAME, ... }
   */
  const renderSuggestionList = (data) => {
    if (commonFunction.isValueEmpty(data) || data.length === 0) {
      return <p className={props.styles.no_result_found}>No Results Found!!</p>;
    }

    const firstType = data[0] && data[0].TYPE;
    const isV2 = firstType === "CITY" || firstType === "EXACT";

    if (isV2) {
      return data.map((item, i) => {
        if (item.TYPE === "CITY") {
          const suggestions = item.SUGGESTIONS || [];
          // If only 1 suggestion and its code matches the city code, it's a
          // single-airport city (e.g. YXU). Skip the "All airports" header and
          // render just the one airport row to avoid a duplicate entry.
          const isSingleSameCode =
            suggestions.length === 1 &&
            suggestions[0].AIRPORT_CODE === item.CITY_CODE;

          if (isSingleSameCode) {
            const airport = suggestions[0];
            return (
              <div key={"cityGroup" + i} className={props.styles.flights_city_main}>
                <div
                  id="flightData"
                  className={`${props.styles.flight_autocomplete_element} ${props.styles.flight_autocomplete_city_row}`}
                  onClick={() => selectAirportClickHandler(airport)}
                  tabIndex="2"
                >
                  <div className={props.styles.fltg_icon}>
                    <span>{props.leftIcon}</span>
                  </div>
                  <div className={props.styles.flight_autocomplete_name}>
                    {airport.CITY_NAME}, {airport.COUNTRY_NAME}
                    <span>{airport.AIRPORT_NAME}</span>
                  </div>
                  <div className={props.styles.flight_autocomplete_tag}>
                    {airport.AIRPORT_CODE}
                  </div>
                </div>
              </div>
            );
          }

          // Multiple airports — city header row + indented airport children
          return (
            <div key={"cityGroup" + i} className={props.styles.flights_city_main}>
              {/* City (parent) row — clicking books CITY_CODE (all airports) */}
              <div
                id="flightData"
                className={`${props.styles.flight_autocomplete_element} ${props.styles.flight_autocomplete_city_row}`}
                onClick={() => selectCityClickHandler(item)}
                tabIndex="2"
              >
                <div className={props.styles.fltg_icon}>
                  <span>{props.leftIcon}</span>
                </div>
                <div className={props.styles.flight_autocomplete_name}>
                  {item.CITY_NAME}, {item.COUNTRY_NAME}
                  <span>All airports</span>
                </div>
                <div className={props.styles.flight_autocomplete_tag}>
                  {item.CITY_CODE}
                </div>
              </div>

              {/* Airport (child) rows — indented */}
              {suggestions.map((airport, j) => (
                <div
                  id="flightData"
                  key={"airport" + i + "_" + j}
                  className={`${props.styles.flight_autocomplete_element} ${props.styles.flight_autocomplete_airport_row}`}
                  onClick={() => selectAirportClickHandler(airport)}
                  tabIndex="2"
                >
                  <div className={props.styles.sub_arrow_wrapper}>
                    <img src="/images/sub_arrow.svg" alt="sub_arrow" />
                  </div>
                  <div className={props.styles.fltg_icon}>
                    <span>{props.leftIcon}</span>
                  </div>
                  <div className={props.styles.flight_autocomplete_name}>
                    {airport.CITY_NAME}, {airport.COUNTRY_NAME}
                    <span>{airport.AIRPORT_NAME}</span>
                  </div>
                  <div className={props.styles.flight_autocomplete_tag}>
                    {airport.AIRPORT_CODE}
                  </div>
                </div>
              ))}
            </div>
          );
        }

        if (item.TYPE === "EXACT") {
          // Exact airport match: pinned row + nearby children from SUGGESTIONS[]
          return (
            <div key={"exactGroup" + i} className={props.styles.flights_city_main}>
              {/* Exact airport row — pinned, no indent */}
              <div
                id="flightData"
                className={`${props.styles.flight_autocomplete_element} ${props.styles.flight_autocomplete_city_row}`}
                onClick={() => selectAirportClickHandler(item)}
                tabIndex="2"
              >
                <div className={props.styles.fltg_icon}>
                  <span>{props.leftIcon}</span>
                </div>
                <div className={props.styles.flight_autocomplete_name}>
                  {item.CITY_NAME}, {item.COUNTRY_NAME}
                  <span>{item.AIRPORT_NAME}</span>
                </div>
                <div className={props.styles.flight_autocomplete_tag}>
                  {item.AIRPORT_CODE}
                </div>
              </div>

              {/* Nearby airports — indented children from SUGGESTIONS[] */}
              {item.SUGGESTIONS &&
                item.SUGGESTIONS.length > 0 &&
                item.SUGGESTIONS.map((airport, j) => (
                  <div
                    id="flightData"
                    key={"nearby" + i + "_" + j}
                    className={`${props.styles.flight_autocomplete_element} ${props.styles.flight_autocomplete_airport_row}`}
                    onClick={() => selectAirportClickHandler(airport)}
                    tabIndex="2"
                  >
                    <div className={props.styles.fltg_icon}>
                      <span>{props.leftIcon}</span>
                    </div>
                    <div className={props.styles.flight_autocomplete_name}>
                      {airport.CITY_NAME}, {airport.COUNTRY_NAME}
                      <span>{airport.AIRPORT_NAME}</span>
                    </div>
                    <div className={props.styles.flight_autocomplete_tag}>
                      {airport.AIRPORT_CODE}
                    </div>
                  </div>
                ))}
            </div>
          );
        }

        // Fallback for any unrecognised v2 TYPE — render as flat airport row
        return (
          <div className={props.styles.flights_city_main} key={"v2fallback" + i}>
            <div
              id="flightData"
              className={props.styles.flight_autocomplete_element}
              onClick={() => selectAirportClickHandler(item)}
              tabIndex="2"
            >
              <div className={props.styles.fltg_icon}>
                <span>{props.leftIcon}</span>
              </div>
              <div className={props.styles.flight_autocomplete_name}>
                {item.CITY_NAME}, {item.COUNTRY_NAME}
                <span>{item.AIRPORT_NAME}</span>
              </div>
              <div className={props.styles.flight_autocomplete_tag}>
                {item.AIRPORT_CODE}
              </div>
            </div>
          </div>
        );
      });
    }

    // Legacy flat format fallback (default airports, old API shape)
    return data.map((element, i) => (
      <div className={props.styles.flights_city_main} key={"legacy" + i}>
        <div
          id="flightData"
          className={props.styles.flight_autocomplete_element}
          onClick={() => selectAirportClickHandler(element)}
          tabIndex="2"
        >
          <div className={props.styles.fltg_icon}>
            <span>{props.leftIcon}</span>
          </div>
          <div className={props.styles.flight_autocomplete_name}>
            {element.CITY_NAME}, {element.COUNTRY_NAME}
            <span>{element.AIRPORT_NAME}</span>
          </div>
          <div className={props.styles.flight_autocomplete_tag}>
            {element.AIRPORT_CODE}
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div
      className={props.styles.flight_search_wid_inputfield}
      ref={props.listWrapper}
      id={`Flight_${props.label}_${props.id}`}
    >
      <label>{props.label}</label>
      <div className={props.styles.autocomplet_wrap}>
        <span className={props.styles.flight_search_left_icon}>
          {props.leftIcon}
        </span>
        <input
          type="text"
          autoComplete={"off"}
          id={props.id ? props.id : "myTextField"}
          placeholder={
            !commonFunction.isValueEmpty(props.placholder)
              ? props.placholder
              : ""
          }
          className={props.styles.search_widget_input_new}
          value={!commonFunction.isValueEmpty(props.value) ? props.value : ""}
          onChange={(event) => {
            props.onChangeSourceAndDestination(
              event.target.value.replace(/[^a-zA-Z\s]/g, "")
            );
          }}
          onClick={onClickHandler}
          onFocusCapture={onClickHandler}
          onFocus={onFocusInputHandler}
        />
      </div>

      {!commonFunction.isValueEmpty(props.isError) && props.isError === true ? (
        <div
          className={
            props.isModifySearch
              ? props.styles.error_srp
              : props.styles.flight_search_error_message
          }
        >
          <span>
            {!commonFunction.isValueEmpty(props.errorMessage)
              ? props.errorMessage
              : "Invalid field"}
          </span>
        </div>
      ) : null}

      {/* Multicity — From dropdown */}
      {props?.state?.isMultiCitySearch === true &&
      props.state.selectedDepartureIndex === props.index &&
      props.label === "From" &&
      props.expandAutoCompleteBool === true ? (
        <div
          ref={props.listWrapper}
          tabIndex="2"
          className={props.styles.flight_autocomplete_value}
          id={`Flight_${props.label}_${props.id}`}
        >
          {renderSuggestionList(props.autoCompleteData)}
        </div>
      ) : null}

      {/* Multicity — To dropdown */}
      {props?.state?.isMultiCitySearch === true &&
      props.state.selectedGoingToIndex === props.index &&
      props.label === "To" &&
      props.expandAutoCompleteBool === true ? (
        <div
          ref={props.listWrapper}
          tabIndex="2"
          className={props.styles.flight_autocomplete_value}
          id={`Flight_${props.label}_${props.id}`}
        >
          {renderSuggestionList(props.autoCompleteData)}
        </div>
      ) : null}

      {/* One Way / Round Trip dropdown */}
      {props?.state?.isMultiCitySearch === false &&
      props.expandAutoCompleteBool === true ? (
        <div
          ref={props.listWrapper}
          tabIndex="2"
          className={props.styles.flight_autocomplete_value}
          id={`Flight_${props.label}_${props.id}`}
        >
          <div
            className={
              !commonFunction.isValueEmpty(props.autoCompleteData) &&
              props.autoCompleteData.length > 0
                ? props.styles.flights_city_parent
                : props.styles.flights_city_parent_unset
            }
          >
            {renderSuggestionList(props.autoCompleteData)}
          </div>
        </div>
      ) : null}
    </div>
  );
}
